<div class="search-bar">
  <div
    [ngClass]="{
      'small-search': variant === 'small',
      'search-input': variant === 'default'
    }"
  >
    <div class="search-icon" *ngIf="showIcon">
      <img [src]="iconPath" alt="Search icon" />
    </div>
    <input
      #searchInput
      type="text"
      [placeholder]="placeholder"
      (input)="onSearchInput($event)"
      (keyup.enter)="onSearchSubmit()"
      [value]="searchTerm"
      class="search-field"
      (focus)="onSearchFocus(true)"
      (blur)="onSearchFocus(false)"
    />
    <button
      *ngIf="searchTerm"
      class="clear-button"
      (click)="clearSearch()"
      type="button"
      aria-label="Clear search"
    >
      ×
    </button>
  </div>
  <div class="hint-text" *ngIf="hintText.length">{{ hintText }}</div>
</div>

<!-- <div class="small-search" *ngIf="variant === 'small'">
  <input
    name="search"
    type="text"
    [value]="searchTerm"
    [placeholder]="placeholder"
    (input)="onSearchInput($event)"
    (keyup.enter)="onSearchSubmit()"
    class="search-input"
  />
  <mat-icon class="search-icon">search</mat-icon>
</div> -->
